import * as React from 'react';

import { useStaticQuery, graphql } from 'gatsby';
import useLiveData from 'hooks/useLiveData';
import { Typography, Box, Container, Button } from '@mui/material';
import Grid from '@mui/material/Grid2';
import Link from 'components/Link';
//import theme from 'utils/theme';
import MobileMenu from 'components/MobileMenu';
import Image from 'components/Image';

import logo from 'images/logo.svg';
import logoSmall from 'images/z-small.svg';
import menu from 'images/menu.svg';
import close from 'images/close.svg';

const Header = (props) => {
	const data = useStaticQuery(graphql`
		query headerMenu {
		  allMainMenu:allContentMenu (filter: {menuID: {eq: "main"}}) {
		    edges {
		      node {
		        pages
		      }
		    }
		  }
		}
	`);
	const { response } = useLiveData({
		type: 'ContentMenu',
		method: 'all',
		apiParams: {
			menuID: 'main',
		},
		graphqlKey: 'allMainMenu',
		staticData: data,
	});

	// const [showOffCanvas, setShowOffCanvas] = React.useState(false);
	const [showMobileMenu, setShowMobileMenu] = React.useState(false);
	const mobileMenuButton = React.useRef(null);


	const closeMenu = () => {
		setShowMobileMenu(false);
	}

	const toggleMobileMenu = (evt) => {
		setShowMobileMenu(!showMobileMenu);
	}

	const mainLinks = response.data[0].pages.filter(item => {
		if (item.visible === 'true' || item.visible === true) return true;
		return false;
	});

	const style = {
		position: 'fixed',
		zIndex: 50000,
		width: '100%',
	}

	return (
		<>
			<header style={style}>
				<Container className={`header__container ${showMobileMenu ? 'menu-is-open' : ''}`} maxWidth="false">
					<Grid container alignItems="center" justifyContent="space-between" rowSpacing="0" spacing="0">
						<Grid size={4}>
							<Box className="logo">
								<Link href="/" title="Zehnder Communications, Inc.">
									<Image className="logoImageSmall" loading="eager" src={logoSmall} width="42" height="42" alt="Zehnder Communications, Inc." />
									<Image className="logoImageLarge" loading="eager" src={logo} width="224" height="51" alt="Zehnder Communications, Inc." />
								</Link>
							</Box>
						</Grid>
						<Grid size={8}>
							<nav className="header__nav">
								<ul>
									{mainLinks.map((item, index) => <li key={index}><Link href={item.href} activeClassName="active" partiallyActive={true}><Typography variant="nav">{item.text}</Typography></Link></li>)}
								</ul>
							</nav>
							<Button className="navMenuButton" ref={mobileMenuButton} onClick={toggleMobileMenu} variant="silent"><Image width="56" height="56" src={(showMobileMenu ? close : menu)} alt="Open navigation menu." /></Button>
						</Grid>
					</Grid>
				</Container>
			</header>
			<MobileMenu open={showMobileMenu} anchor={mobileMenuButton?.current} onClose={closeMenu} />
		</>
	)
}

export default Header;